/**
 * @author Samuel Gonzalez
 * Proposito: Establece las rutas de la página principal, donde carga
 *            el contenido
 */

import { Routes } from '@angular/router';
import { ScoreComponent } from '../score/score.component';


export const HomeRoutes: Routes = [
    {
        path: 'score',
        component: ScoreComponent,
        outlet: "outlet1"
    },
];